<template>
  <div>
    <vs-card class="cstm_vx_card mb-4">
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="md:w-1/2 w-full p-1">
            <vs-input placeholder="Search" v-model="search"  @keyup="searchFun" class="w-full"></vs-input>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Filter" position="top">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-filter"
                @click="handlefilterSidebar"
              />
            </vs-tooltip>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Filter View" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="overallSearch"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <rect width="18" height="18" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14ZM11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.1465 16.3536L13.1465 14.3536L13.8536 13.6465L15.8536 15.6465L15.1465 16.3536Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H15C16.3807 0.5 17.5 1.61929 17.5 3V14.5H16.5V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V15C1.5 15.8284 2.17157 16.5 3 16.5H13.5V17.5H3C1.61929 17.5 0.5 16.3807 0.5 15V3Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.5 5.5H1.5V4.5H16.5V5.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 8.5H1.5V7.5H7.5V8.5ZM16.5 8.5H15V7.5H16.5V8.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.5 11.5H1.5V10.5H6.5V11.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 14.5H1.5V13.5H7.5V14.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 16.5V5H5.5V16.5H4.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Rearrange Column" position="top">
              <vs-button
                @click="columnRearrangement"
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                icon="published_with_changes"
              >
              </vs-button>
            </vs-tooltip>
          </div>
          <!-- <div class="p-1">
            <vs-tooltip color="primary" text="Import CSV/ XLS" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H22C18.6863 43 16 40.3137 16 37V24.5H18V37C18 39.2091 19.7909 41 22 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 28V32C10 34.2091 11.7909 36 14 36H24V38H14C10.6863 38 8 35.3137 8 32V28H10Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.36396 28.8284L4.41421 33.7782L3 32.364L9.36396 26L15.7279 32.364L14.3137 33.7782L9.36396 28.8284Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Export Template" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H18C14.6863 43 12 40.3137 12 37V24.5H14V37C14 39.2091 15.7909 41 18 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 26V30C8 32.2091 9.79086 34 12 34H22V36H12C8.68629 36 6 33.3137 6 30V26H8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.8995 34.6569L16.9498 39.6066L18.364 41.0208L24.728 34.6569L18.364 28.2929L16.9498 29.7071L21.8995 34.6569Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div> -->
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-row vs-type="flex" vs-justify="flex-end" vs-align="center">
            <vs-button class="btnx" @click="addNotes = true">
              Create Notes
            </vs-button>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-card>
        <div v-if="overallSearchHolder">
      <vs-card class="cstm_vx_card mb-4">
        <div slot="header">
          <h4>Filter View</h4>
        </div>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="sm:block block lg:flex"
          >
            <div class="lg:w-1/3 w-full p-1">

               <v-select
              placeholder="Select View"
              v-if="user_main_filter"
              class="w-full"
              label="filter_name"
              :options="user_main_filter"
              :reduce="(item) => item.id"
              :clearable="false"
              v-model="select_filter_id"
              @input="getFilter()"
            >
            </v-select>
            </div>
            <div class="flex p-1">
              <vs-tooltip color="primary" text="Reset Filters" position="top">
                <vs-button
                  type="border"
                  icon-pack="feather"
                  @click="resetSearch"
                  icon="icon-refresh-cw"
                ></vs-button>
              </vs-tooltip>
            </div>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>
    <ag-grid-vue
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :tooltipMouseTrack="true"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="NotetemplateList"
      rowSelection="multiple"
      :enableRtl="$vs.rtl"
      colResizeDefault="true"
      :animateRows="true"
      :floatingFilter="false"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :style="{ minHeight: NotetemplateList.length * 48 + 75 + 'px' }"
      :suppressPaginationPanel="true"
      @grid-ready="onGridReady"
      @sortChanged="sortFun"
    ></ag-grid-vue>
    <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
      <vs-col vs-w="4" vs-type="flex" vs-justify="start" vs-align="center">
        <ItemsPerTableDropdown
          tableName="note_template_list"
          @change="(pageLimit) => (pageLimitSet = pageLimit)"
        />
      </vs-col>
      <pagination
        :meta="meta"
        @page-change="handlePageChange"
        class="ml-auto"
      />
    </vs-row>
    <div v-if="addNotes">
      <createNote
        :addNotes="addNotes"
        @closeNoteTemplateModal="closeNoteTemplateModal"
        :type="type"
        :editPayload="editPayload"
      />
    </div>


    <vs-popup
      class="popup"
      title="Column Rearrangement"
      :active.sync="columnRearrangementModal"
    >
      <RearrangeManagement
        v-if="columnRearrangementModal"
        moduleProps="Lesson Notes"
        headername="Lesson Notes Template"
        table_name="note_template_list"
        @closeRearrangementModal="closeRearrangementModal"
      ></RearrangeManagement>
    </vs-popup>


      <filter-sidebar
      :isSidebarActive="filterSidebarBoolean"
      :fieldtabledata="fieldtabledata"
      :filterconditiondata="filterconditiondata"
      platformmodulename="Lesson Notes"
      @closedsidebarevent="filterSidebarEvent"
      name="note_template_list"
    ></filter-sidebar>
  </div>
</template>

<script>
import { DynamicFilter } from '@/mixins/dynamic-filter'

import FilterSidebar from '@/components/common/filter-sidebar'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

import CustomTooltip from '@/views/pages/v1/notes/NotesCustomTooltip.js'

import Vue from 'vue'
import notesSubject from '@/views/pages/v1/notes/notesSubjectComponent.vue'
import CellRendererNoteAction from '@/views/pages/v1/notes/components/Template/CellRendererActionNoteTemplate.vue'
import pagination from '@/components/common/pagination.vue'
import createNote from '@/views/pages/v1/notes/components/Template/createNote.vue'
import vSelect from 'vue-select'
import { get_lesson_note_list } from '@/api/lesson_notes'

import RearrangeManagement from '@/views/pages/customFieldRearrage/columnRearrangeWithoutDynamic.vue'
import { fetchField } from '@/api/columnrearrange.js'

export default {
  mixins: [DynamicFilter],
  components: {
    AgGridVue,
    notesSubject,
    CustomTooltip,
    pagination,
    createNote,
    FilterSidebar,
    vSelect,
    RearrangeManagement
  },
  created () {

    this.fetchingDynamicFieldAndFilter()
    this.fetchMainFilter('Lesson Notes','note_template_list')
    this.fetchDisplayFields('Lesson Notes', this.$store.getters.customerId)
  },
  beforeMount () {
    this.tooltipShowDelay = 0
    this.frameworkComponents = {
      customTooltip: CustomTooltip
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.fetchNotesTemplate()
  },
  data () {
    return {
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      filterSidebarBoolean: false,
      search:'',
      addNotes: false,
      type: 'Add',
      pageLimitSet: 5,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      gridApi: null,
      gridOptions: {},
      gridColumnApi: null,
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      NotetemplateList: [],
      columnApi: null,
      components: {},
      add_description: true,
      privateToggle: false,

      columnDefs: [],
      editPayload: null,
      select_filter_id: null,
      overallSearchHolder:false,
      columnRearrangementModal:false,
      staticField: [
        {
          headerName: '',
          minWidth: 60,
          maxWidth: 60,
          field: 'isSelected',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '#',
          field: 'row_index',
          sortable: false,
          filter: false,
          minWidth: 100,
          maxWidth: 100,
          resizable: true,
          editable: false,
          valueGetter: (params) => {
            return (
              this.meta.limit * (this.meta.current_page - 1) +
            params.node.rowIndex +
            1
            )
          }
        },
        {
          headerName: 'Title',
          field: 'title',
          filter: true,
          minWidth: 150,
          resizable: true,
          editable: false,
          // comparator: (params) => {}
        },
        {
          headerName: 'Description',
          field: 'description',
          filter: true,
          minWidth: 150,
          maxWidth: 150,
          resizable: true,
          editable: false,
          // comparator: (params) => {}
        },
        {
          headerName: 'Subject',
          field: 'subject',
          filter: true,
          minWidth: 150,
          maxWidth: 150,
          resizable: true,
          editable: false,
          tooltipField: 'subjects',
          // comparator: (params) => {},
          tooltipComponentParams: { color: '#fff' },
          floatingFilterComponentParams: {
            floatingFilterComponentParams: false
          },
          cellRendererFramework: Vue.extend(notesSubject)
        },
        {
          headerName: 'Course',
          field: 'course',
          filter: true,
          minWidth: 150,
          maxWidth: 150,
          resizable: true,
          editable: false,
          // comparator: (params) => {},
          valueGetter: (params) => {
            return params.data.course.length > 0
              ? this.getCourses(params.data.course)
              : 'Not Attached'
          }
        },
        {
          headerName: 'Actions',
          field: 'actions',
          minWidth: 100,
          maxWidth: 100,
          resizable: true,
          editable: false,
          sortable: false,
          cellRendererFramework: Vue.extend(CellRendererNoteAction),
          filterParams: {
            openEditView: this.openEditView,
            openPreview: this.openPreview,
            fetchNotesTemplate: this.fetchNotesTemplate
          }
        }
      ]
    }
  },
  watch: {
    columnRearrangementModal () {
      if (!this.columnRearrangementModal) {
        this.fetchingDynamicFieldAndFilter()
        this.fetchDisplayFields('Lesson Notes', this.$store.getters.customerId).then(() => {
          this.gridOptions.api.sizeColumnsToFit()
        })
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  methods: {
    async fetchDisplayFields (moduleName, customerId) {
      try {
        const payload = {
          customer_id: customerId,
          fetch_status: 'display',
          type: moduleName,
          table_name:'note_template_list'
        }
        const { data } = await fetchField(payload)
        const displayList = data.data.results

        let displayColomns = []
        if (displayList.length === 0) {
          displayColomns = this.staticField
        } else {
          for (const item of displayList) {
            let _tempObj = {}
            if (item.field_label === 'Subject') {
              _tempObj = {
                headerName: 'Subject',
                field: 'subject',
                filter: true,
                minWidth: 150,
                maxWidth: 150,
                resizable: true,
                editable: false,
                tooltipField: 'subjects',
                table_name:item.table_name,
                // comparator: (params) => {},
                tooltipComponentParams: { color: '#fff' },
                floatingFilterComponentParams: {
                  floatingFilterComponentParams: false
                },
                cellRendererFramework: Vue.extend(notesSubject)

              }
              displayColomns.push(_tempObj)
            } else if (item.field_label === 'Course') {
              _tempObj = {
                headerName: 'Course',
                field: 'course',
                filter: true,
                table_name:item.table_name,
                minWidth: 150,
                maxWidth: 150,
                resizable: true,
                editable: false,
                // comparator: (params) => {},
                valueGetter: (params) => {
                  return params.data.course.length > 0
                    ? this.getCourses(params.data.course)
                    : 'Not Attached'
                }
              }
              displayColomns.push(_tempObj)
            } else {
              _tempObj = {
                headerName: item.field_label,
                field: item.field_name,
                filter: true,
                minWidth: 100,
                resizable: true,
                editable: false,
                table_name:item.table_name,
                comparator: (valueA) => {}

              }
              displayColomns.push(_tempObj)
            }

          }
          const staticField2 = {
            headerName: '#',
            field: 'row_index',
            filter: false,
            minWidth: 100,
            maxWidth: 100,
            sortable: false,
            editable: false,
            valueGetter:(params) => {
              return ((this.meta.limit * (this.meta.current_page - 1)) + params.node.rowIndex + 1)
            }
          }
          displayColomns.unshift(staticField2)
          const _tempObj = {
            headerName: 'Actions',
            field: 'actions',
            minWidth: 100,
            maxWidth: 100,
            resizable: true,
            editable: false,
            sortable: false,
            cellRendererFramework: Vue.extend(CellRendererNoteAction),
            filterParams: {
              openEditView: this.openEditView,
              openPreview: this.openPreview,
              fetchNotesTemplate: this.fetchNotesTemplate
            }
          }
          displayColomns.push(_tempObj)


        }


        this.columnDefs = displayColomns

        this.gridOptions.api.sizeColumnsToFit()

      } catch (e) {
        console.warn(e)
      }
    },
    closeRearrangementModal (value) {
      if (value) {
        this.columnRearrangementModal = false
      }
    },
    columnRearrangement () {
      this.columnRearrangementModal = true
    },
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId === 'subjects') {
        field_name = 'subject'
      }

      return field_name
    },
    async sortFun () {
      try {
        const sortState = this.gridApi.getSortModel()
        if (sortState.length === 0) {
          console.log('No sort active')
          this.sorting_obj.field_type = ''
          this.sorting_obj.attribute = ''
          this.sorting_obj.direction = ''

          this.fetchNotesTemplate()
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          this.sorting_obj.direction = sortState[0].sort
          this.fetchNotesTemplate()
        }
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    resetSearch () {
      this.select_filter_id = null
      this.search = ''
      this.handlePageChange(1)
    },
    overallSearch () {
      this.overallSearchHolder = !this.overallSearchHolder
    },
    getFilter () {
      // const query = {
      //   page: 1,
      //   limit: this.pageLimitSet,
      //   customerId: this.$store.getters.customerId
      // }
      if (this.select_filter_id === null) {
        this.fetchNotesTemplate()
      } else {
        const filter_id = this.select_filter_id

        this.fetchNotesTemplate(filter_id)
      }
    },
    fetchingDynamicFieldAndFilter () {
      this.fetchFieldAndFilterList('Lesson Notes', 'note_template_list') //this is fetching dynamic field and static field for filter modules
    },
    handlefilterSidebar () {
      this.filterSidebarBoolean = !this.filterSidebarBoolean
      document.body.classList.add('overflow-hidden')
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.fetchNotesTemplate()
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    openEditView (editPayload) {
      this.type = 'Edit'
      this.addNotes = true
      this.editPayload = editPayload
    },
    openPreview (editPayload) {
      this.type = 'Preview'
      this.addNotes = true
      this.editPayload = editPayload
    },
    handlePageChange (page) {
      this.meta.current_page = page || this.meta.current_page + 1
      this.fetchNotesTemplate()
    },
    getCourses (courses) {
      const res = courses.map((element) => {
        return element.name
      })
      return res.join(', ')
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    async fetchNotesTemplate (filter_id = null) {
      const payload = {
        limit: this.pageLimitSet,
        type:'template',
        search:this.search
      }
      const { data } = await get_lesson_note_list(
        localStorage.getItem('customer_id'),
        this.meta.current_page,
        payload,
        filter_id,
        this.sorting_obj,
        'note_template_list'
      )

      this.NotetemplateList = data.data.note
      this.meta = data.data.meta

      this.gridOptions.api.sizeColumnsToFit()

    },
    closeNoteTemplateModal () {
      this.fetchNotesTemplate()
      this.addNotes = false
      this.type = 'Add'
    }
  }
}
</script>
